import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9cda7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roles" }
const _hoisted_2 = { class: "receivers-container" }
const _hoisted_3 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_4 = { class: "col text-wrap text-truncate d-flex align-items-center gap-3" }
const _hoisted_5 = { class: "d-inline-flex align-items-center" }
const _hoisted_6 = { class: "col-auto ms-auto align-self-end align-self-sm-start mb-2 mb-sm-0 mx-sm-2" }
const _hoisted_7 = { class: "mt-sm-0 d-flex col-sm-auto mt-2 col-12 col-sm-auto" }
const _hoisted_8 = { class: "ms-auto" }
const _hoisted_9 = { class: "dt-container dt-container--tabbed" }
const _hoisted_10 = {
  key: 0,
  class: "signage__item-callouts signage__item-callouts--bottom-warning mb-3"
}
const _hoisted_11 = { class: "callout callout--no-max callout--warning" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "Details", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6 px-0 pe-md-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter a name for this role. Example: Web Admin, Teacher, Cleveland Office, etc.", -1))
const _hoisted_17 = { class: "col-md-6 px-0 ps-md-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter a description for the role.", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Digital Signage"),
  /*#__PURE__*/_createElementVNode("span", {
    "aria-label": "required",
    class: "required-asterisk"
  }, "*")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Add Ditto rooms. Team members in this role can manage digital signage for the selected rooms. Roles must include at least one room.", -1))
const _hoisted_21 = { class: "px-1" }
const _hoisted_22 = { class: "d-flex flex-row mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Room Name: ", -1))
const _hoisted_24 = { class: "expanded-table__description" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "px-1" }
const _hoisted_27 = { class: "d-flex flex-row mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Member: ", -1))
const _hoisted_29 = { class: "expanded-table__description" }
const _hoisted_30 = { class: "mt-4 mb-3 text-center" }
const _hoisted_31 = { class: "d-flex" }
const _hoisted_32 = { style: {"width":"100%","text-align":"right"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roles-details__select-cell" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "el-dialog__title" }, "Select Members to Add", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Add members to this role.", -1))
const _hoisted_36 = { class: "d-flex align-items-center gap-3" }
const _hoisted_37 = {
  key: 0,
  class: "role-details__user-list-header"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "User Name", -1))
const _hoisted_39 = {
  key: 1,
  class: "roles-details__members-list"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "roles-details__members-list-details" }
const _hoisted_42 = { class: "roles-details__members-list-name" }
const _hoisted_43 = { class: "roles-details__members-list-role" }
const _hoisted_44 = {
  key: 2,
  class: "m-0 mt-4 p-0 text-center"
}
const _hoisted_45 = {
  key: 1,
  class: "my-2 p-0 text-center"
}
const _hoisted_46 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_ModelSelector = _resolveComponent("ModelSelector")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "primary-color",
            to: "/roles"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Digital Signage Roles")
            ]),
            _: 1
          }),
          (_ctx.role && _ctx.role.name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" » "),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_Icon, {
                    style: _normalizeStyle({ fill: _ctx.role.color }),
                    class: "role-icon--name me-2",
                    icon: _ctx.role.name === 'Admin' ? _ctx.mdiShieldStar : _ctx.mdiShieldLock
                  }, null, 8, ["style", "icon"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.creationMode ? 'New Role' : _ctx.role.name), 1)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/roles/" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              onClick: _ctx.onSaveHandler,
              type: "primary",
              disabled: _ctx.role.readOnly
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.creationMode ? "Create" : "Save") + " Role", 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTab) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "Overview",
              name: "overview"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  rules: _ctx.rules,
                  "hide-required-asterisk": "",
                  ref: "form",
                  "label-position": "top",
                  model: _ctx.role,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isRoleSystemRole)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("span", null, "This is a system role and cannot be edited. " + _toDisplayString(_ctx.role.name.toLowerCase() === 'admin' ? 'Admins have access to the entire Ditto Account Portal.' : 'Users have access to the entire Ditto Account Portal except Users, Roles and Billing.'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_el_form_item, {
                          class: "mb-4 mb-md-0",
                          label: "Role Name",
                          prop: "name"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16,
                            _createVNode(_component_el_input, {
                              disabled: _ctx.role.readOnly,
                              modelValue: _ctx.role.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.role.name) = $event)),
                              placeholder: "Role Name"
                            }, _createSlots({ _: 2 }, [
                              (_ctx.role.readOnly)
                                ? {
                                    name: "append",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_Icon, {
                                        class: "read-only-icon",
                                        icon: _ctx.mdiLock
                                      }, null, 8, ["icon"])
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_el_form_item, {
                          class: "mb-0",
                          label: "Role Description",
                          prop: "description"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            _createVNode(_component_el_input, {
                              disabled: _ctx.role.readOnly,
                              modelValue: _ctx.role.description,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.role.description) = $event)),
                              placeholder: "Role Description"
                            }, _createSlots({ _: 2 }, [
                              (_ctx.role.readOnly)
                                ? {
                                    name: "append",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_Icon, {
                                        class: "read-only-icon",
                                        icon: _ctx.mdiLock
                                      }, null, 8, ["icon"])
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (!_ctx.role.readOnly)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_divider),
                          _hoisted_19,
                          _hoisted_20,
                          _createVNode(_component_el_form_item, {
                            ref: "roomFormItem",
                            prop: "rooms"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_tooltip, {
                                  effect: "dark",
                                  disabled: _ctx.isAdmin,
                                  content: "Contact an admin to manage rooms",
                                  placement: "top",
                                  "hide-after": 0,
                                  "show-after": 500
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      class: _normalizeClass(["d-inline-block mb-2", {'is-disabled': !_ctx.isAdmin }]),
                                      type: "primary",
                                      onClick: _ctx.activateRoomManagementSelector
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Manage Rooms (" + _toDisplayString(_ctx.roomCount) + ") ", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["class", "onClick"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _createVNode(_component_el_table, {
                                "empty-text": "No rooms selected",
                                data: _ctx.assignedRooms,
                                prop: "rooms"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.windowWidth.value < 576)
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        type: "expand",
                                        width: "55"
                                      }, {
                                        default: _withCtx((props) => [
                                          _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                              _hoisted_23,
                                              _createElementVNode("div", _hoisted_24, _toDisplayString(props.row.roomName), 1)
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_table_column, {
                                    prop: "roomName",
                                    label: "Room Name",
                                    sortable: ""
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_router_link, {
                                          class: "el-table-column__name me-2 me-sm-0",
                                          to: `/rooms/${scope.row.id}`
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(scope.row.roomName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"])
                            ]),
                            _: 1
                          }, 512)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["rules", "model"])
              ]),
              _: 1
            }),
            (!_ctx.creationMode)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: 'Members (' + _ctx.usersOfThisRole.length + ')',
                  name: "members"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      "empty-text": "There are no members in this role.",
                      data: _ctx.usersOfThisRole
                    }, {
                      default: _withCtx(() => [
                        (_ctx.windowWidth.value < 576)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              type: "expand",
                              width: "55"
                            }, {
                              default: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _hoisted_28,
                                    _createElementVNode("div", _hoisted_29, _toDisplayString(props.row.name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      plain: "",
                                      round: "",
                                      id: props.row
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Remove Member")
                                      ]),
                                      _: 2
                                    }, 1032, ["id"])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_table_column, {
                          prop: "name",
                          label: "Member Name",
                          sortable: ""
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_el_tooltip, {
                                effect: "dark",
                                disabled: _ctx.myId !== scope.row.id,
                                content: "This is you",
                                placement: "top",
                                "hide-after": 0,
                                "show-after": 500
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    class: "el-table-column__name me-2 me-sm-0",
                                    to: `/users/${scope.row.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.myId == scope.row.id)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            class: "user-icon me-1",
                                            icon: _ctx.mdiAccount
                                          }, null, 8, ["icon"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1032, ["disabled"])
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.windowWidth.value >= 576)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 1,
                              prop: "id"
                            }, {
                              header: _withCtx(() => [
                                _createElementVNode("div", _hoisted_32, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    class: "ms-auto",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMemberSelectionModalVisible = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Add Members")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              default: _withCtx(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_ModelSelector, {
        title: "Add Rooms to Role",
        subTitle: _ctx.role.name,
        modelTypeName: "rooms",
        ref: "modelSelector",
        onSelectionPoolChange: _ctx.roomSelectionChanged,
        addButton: true,
        includesAll: true
      }, null, 8, ["subTitle", "onSelectionPoolChange"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.isMemberSelectionModalVisible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isMemberSelectionModalVisible) = $event)),
        onClosed: _ctx.memberDialogClosedHandler
      }, {
        title: _withCtx(() => [
          _hoisted_34,
          _hoisted_35
        ]),
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_46, [
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isMemberSelectionModalVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.onAddMembersHandler,
              disabled: !_ctx.availableUsers.length,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])), [
              [_directive_loading, _ctx.isAddMembersLoading]
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.availableUsers.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_el_input, {
                      class: "flex-grow-2 role-details__list-search roles-details__members-list-search",
                      clearable: "",
                      placeholder: "Search users",
                      modelValue: _ctx.membersListSearch,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.membersListSearch) = $event))
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          class: "role-details__list-search-icon",
                          icon: _ctx.mdiMagnify
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      placeholder: "Filter by role",
                      clearable: "",
                      modelValue: _ctx.membersListFilter,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.membersListFilter) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: role.id,
                            label: role.name,
                            value: role.name
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (_ctx.filteredAvailableUsers.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createVNode(_component_el_checkbox, {
                          onClick: _withModifiers(_ctx.selectAllUsersHandler, ["prevent","stop"]),
                          class: "roles-details__members-list-check",
                          "model-value": _ctx.isAllUsersChecked
                        }, null, 8, ["onClick", "model-value"]),
                        _hoisted_38
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filteredAvailableUsers.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableUsers, (user) => {
                          return (_openBlock(), _createElementBlock("li", {
                            onClick: ($event: any) => (_ctx.userSelectedHandler(user)),
                            class: "roles-details__members-list-item",
                            key: user.id
                          }, [
                            _createVNode(_component_el_checkbox, {
                              onClick: _withModifiers(($event: any) => (_ctx.userSelectedHandler(user)), ["prevent","stop"]),
                              class: "roles-details__members-list-check",
                              modelValue: user.selected,
                              "onUpdate:modelValue": ($event: any) => ((user.selected) = $event)
                            }, null, 8, ["onClick", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(user.name), 1),
                              _createElementVNode("span", _hoisted_43, _toDisplayString(user.roleName), 1)
                            ])
                          ], 8, _hoisted_40))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_44, "There are no users that match this search."))
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_45, "There are no more available members to make this role."))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"])
    ])), [
      [_directive_loading, _ctx.isLoading]
    ]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock roles."
    }, null, 8, ["modelValue"])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}